import { io } from "socket.io-client";
const STT_SOCKET_IO_URL = process.env.REACT_APP_STT_SOCKET_URL

export const sttSocket = io(STT_SOCKET_IO_URL, { // Speach to text socket 
    autoConnect: true,
    path: "/speech/socket",
})